import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES: string[] = ['Code', 'Description'];

export const TermsOfPaymentsDropdown = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;

  const { options: termsOfPaymentsOptions, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /promptValues/{windowId}',
    labelAttribute: 'description',
    valueAttribute: 'termsOfPayment',
    params: {
      windowId: 'termsOfPayments',
    },
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={termsOfPaymentsOptions} columnNames={COLUMN_NAMES} />;
};
